<div class="p-6 bg-gray-50 min-h-screen">
  <!-- Page Header -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 pb-4 border-b border-gray-200">
    <div class="flex items-center gap-3">
      <div class="w-11 h-11 bg-gradient-to-tr from-green-600 to-emerald-400 rounded-xl flex items-center justify-center text-white shadow-md shadow-green-200">
        <i class="fas fa-file-excel text-xl"></i>
      </div>
      <div>
        <h1 class="text-2xl font-bold text-gray-900 tracking-tight">Reports</h1>
        <p class="text-sm text-gray-500">Generate operational reports and download them as Excel files</p>
      </div>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <a routerLink="/reports/agent-insights"
      class="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:border-green-400 hover:shadow-md transition-all block">
      <div class="flex items-center gap-3 mb-2">
        <div class="w-9 h-9 bg-gradient-to-tr from-green-600 to-emerald-400 rounded-lg flex items-center justify-center text-white shrink-0">
          <i class="fas fa-chart-line text-sm"></i>
        </div>
        <h2 class="text-base font-semibold text-gray-900">Agent Insights</h2>
      </div>
      <p class="text-sm text-gray-500">
        Per-agent totals for a date range — collections, scrap value, disposal value, platform fee, collection
        charges, orders under &#8377;300, average order value and voucher conversion.
      </p>
    </a>

    <a routerLink="/reports/customer-collections"
      class="bg-white rounded-xl shadow-sm border border-gray-200 p-5 hover:border-green-400 hover:shadow-md transition-all block">
      <div class="flex items-center gap-3 mb-2">
        <div class="w-9 h-9 bg-gradient-to-tr from-teal-600 to-emerald-400 rounded-lg flex items-center justify-center text-white shrink-0">
          <i class="fas fa-users text-sm"></i>
        </div>
        <h2 class="text-base font-semibold text-gray-900">Customer Collections</h2>
      </div>
      <p class="text-sm text-gray-500">
        Export customers who completed a scrap collection in a date range, filterable by district / zone.
      </p>
    </a>
  </div>
</div>
